<template>
    <PageView>
        <a-card title="列表">
            <a-row :gutter="10" class="inputGroup">
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="searchData.orderno" placeholder="请输入订单号" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="searchData.name" placeholder="请输入收货人" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="searchData.phone" placeholder="请输入手机号" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-input v-model="searchData.provider" placeholder="请输入小程序名称" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-select allowClear v-model="searchData.putaway" style="width:100%" placeholder="选择商品上下架">
                        <a-select-option value="1">上架</a-select-option>
                        <a-select-option value="2">下架</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-select allowClear v-model="selectedColor" @change="handleColorChange" style="width:100%" placeholder="选择商品颜色">
                        <a-select-option v-for="(item,index) in skucolor" :key="index" :value="item">{{ item }}</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-select allowClear v-model="selectedNums" @change="handleNumsChange" style="width:100%" placeholder="选择商品内存">
                        <a-select-option v-for="(item,index) in skunums" :key="index" :value="item">{{ item }}</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-select allowClear v-model="searchData.status" style="width:100%" placeholder="选择订单状态">
                        <a-select-option value="overdue">逾期</a-select-option>
                        <a-select-option value="defeat">扣款失败</a-select-option>
                        <a-select-option value="-1">已取消</a-select-option>
                        <a-select-option value="1">待授权</a-select-option>
                        <a-select-option value="2">待审核</a-select-option>
                        <a-select-option value="3">审核拒绝</a-select-option>
                        <a-select-option value="4">待签署</a-select-option>
                        <a-select-option value="5">签署中</a-select-option>
                        <a-select-option value="6">拒签</a-select-option>
                        <a-select-option value="7">待取货</a-select-option>
                        <a-select-option value="8">使用中</a-select-option>
                        <a-select-option value="9">申请退款</a-select-option>
                        <a-select-option value="10">退款成功</a-select-option>
                        <a-select-option value="11">退款失败</a-select-option>
                        <a-select-option value="12">订单结束</a-select-option>
                        <a-select-option value="13">待发货</a-select-option>
                        <a-select-option value="14">归还中</a-select-option>
                        <a-select-option value="15">待支付</a-select-option>
                        <a-select-option value="16">签署成功</a-select-option>
                    </a-select>
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-range-picker v-model="time" :placeholder="['开始时间', '结束时间']" />
                </a-col>
                <a-col :xs="12" :md="6" :lg="6" :xl="4">
                    <a-button-group>
                        <a-button type="primary" :loading="loading" @click="getList">确定筛选</a-button>
                    </a-button-group>
                    <a-button-group style="margin-left:10px">
                        <a-button type="primary" :loading="loading" @click="getListInit">重置</a-button>
                    </a-button-group>
                </a-col>
            </a-row>
            <a-table
                :loading="loading"
                :columns="columns"
                :dataSource="data"
                :pagination="{ total, pageSize, showSizeChanger, current }"
                @change="changePagination"
                bordered
                :scroll="{ x: true }"
            >
            </a-table>
            <!-- <a-button type="primary" @click="exportExcel" style="float: right">导出表格</a-button> -->
        </a-card>

        <a-modal
            title="查看详细信息"
            :visible="Password"
            centered
            :closable="false"
            :maskClosable="false"
            width="800px"
        >
            <div>
                <!-- 展示 -->
                <div class="juli">商品名称：{{ lentgoods.name }}</div>
                <div class="juli">
                    商品图片：
                    <img :src="lentgoods.img" alt="" style="width:100px;height:100px" />
                </div>
                <div class="juli">商铺名称：{{ lentshop ? lentshop.name : '' }}</div>
            </div>
            <template slot="footer">
                <a-button-group>
                    <a-button type="primary" :loading="btnloading" @click="Password = false">确定</a-button>
                    <a-button type="default" @click="Password = false">关闭</a-button>
                </a-button-group>
            </template>
        </a-modal>
    </PageView>
</template>

<script type="text/jsx">
import Order from '../../api/Order.js'
import {statusOne} from '../../utils/status'
import { mapGetters } from 'vuex'
export default {
    name: 'memberList',
    data () {
        return {
            pwd: '',
            uidTwo: '',
            loading: true,
            Password: false,
            time:0,
            lentgoods:{

            },
            lentshop:{

            },
            columns: [
              {
                    title: '下单时间',
                    dataIndex: 'add_time',
                    customRender: (v) => {
                        return v ? this.timeOne(v) : '暂无'
                    }
                },
                {
                    title: '订单号',
                    dataIndex: 'orderno'
                },
                {
                    title: '收货类型',
                    dataIndex: 'order_type',
                    customRender:(v)=>{
                        return v==1?'到店自取':v==2?'邮寄发货':'到店自取'
                    }
                },
                {
                    title: '收货地址',
                    customRender:(v)=>{
                        return v.order_type==2?v.add_ress ? v.add_ress.pro_str + v.add_ress.add_ress : '空':'暂无'
                    }
                },
                {
                    title: '收货人姓名',
                    customRender:(v)=>{
                        return v.order_type==2?v.add_ress?v.add_ress.name:'空':'暂无'
                    }
                },
                {
                    title: '收货人手机号',
                    customRender:(v)=>{
                        return v.order_type==2?v.add_ress?v.add_ress.phone:'空':'暂无'
                    }
                },
                {
                    title: '小程序',
                    dataIndex: 'provider_name',
                    customRender: (v) => {
                        return v || '暂无'
                    }
                },
                {
                    title: '下单人',
                    dataIndex: 'name'
                },
                {
                    title: '下单人手机号',
                    dataIndex: 'phone'
                },

                {
                    title: '总期数',
                    dataIndex: 'periods',
                    customRender:(v)=>{
                        return v||'暂无'
                    }
                },
                {
                    title: '总额',
                    dataIndex: 'price'
                },
                {
                    title: '首付款',
                    dataIndex: 'down_price'
                },
                {
                    title: '数量',
                    dataIndex: 'sku_num'
                },
                {
                    title: '押金',
                    dataIndex: 'deposit'
                },

                {
                    title: '状态',
                    // dataIndex: 'status',
                    customRender: (v) => {
                        if(v.status == 1){
                            return '待授权'
                        }else if(v.status == 2){
                            return '待审核'
                        }else if(v.status == 3){
                            return '审核拒绝'
                        }else if(v.status == 4){
                            return '待签署'
                        }else if(v.status == 5){
                            return '签署中'
                        }else if(v.status == 6){
                            return '拒签'
                        }else if(v.status == 7){
                            return '待取货'
                        }else if(v.status == 8){
                            return '使用中'
                        }else if(v.status == 9){
                            return '申请退款'
                        }else if(v.status == 10){
                            return '退款成功'
                        }else if(v.status == 11){
                            return '退款失败'
                        }else if(v.status == 12){
                            return '订单结束'
                        }else if(v.status == 13){
                            return '待发货'
                        }else if(v.status == 14){
                            return '归还中'
                        }else if(v.status == 15){
                            return '待支付'
                        }else if(v.status == -1){
                            return '已取消'
                        }else if(v.status == 16){
                            return '签署成功'
                        }
                    }
                },
                {
                    title: '起租时间',
                    dataIndex: 'sta_time',
                    customRender:(v)=>{
                        return v?this.timeOne(v):'暂无'
                    }
                },
                {
                    title: '预计归还日期',
                    dataIndex: 'end_time',
                    customRender:(v)=>{
                        return v?this.timeOne(v):'暂无'
                    }
                },

                {
                    title: '申请退款时间',
                    dataIndex: 'tui_time',
                    customRender:(v)=>{
                        return v?this.timeOne(v):'暂无'
                    }
                },
                {
                    title: '退款描述',
                    dataIndex: 'tui_desc',
                    customRender:(v)=>{
                        return v?v:'暂无'
                    }
                },
                {
                    title: '退款原因',
                    dataIndex: 'tui_content',
                    customRender:(v)=>{
                        return v?v:'暂无'
                    }
                },
                {
                    title: '退款金额',
                    dataIndex: 'tui_price',
                    customRender:(v)=>{
                        return v?v:'暂无'
                    }
                },
                {
                    title: '拒绝退款原因',
                    dataIndex: 'jutui_content',
                    customRender:(v)=>{
                        return v?v:'暂无'
                    }
                },
                {
                    title: '操作',
                    key: 'action',
                    fixed: 'right',
                    width: 110,
                    customRender: (v) => {
                        return (
                            <a-dropdown>
                                <a-menu slot="overlay">
                                    <a-menu-item onClick={() => {
                                        this.GetPassword(v.uid,v)
                                    }}>查看详细信息
                                    </a-menu-item>
                                </a-menu>
                                <a-button>操作 <a-icon type="down"/></a-button>
                            </a-dropdown>
                        )
                    }
                }
            ],
            data: [],
            total: 0,
            pageSize: 10,
            current: 1,
            showSizeChanger: true,
            searchData: {
                orderno: '',
                name: '',
                phone: '',
                provider:'',
                status:undefined,
                putaway:undefined,
            },
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 }
            },
            btnloading: false,
            money: {
                paidan_moeny: 0,
                shouyi_money: 0,
                gudong_moeny: 0,
                quota: 0
            },
            statustwo:'',
            OrderDueid:'',
            skucolor:[],
            selectedColor: undefined,  // 存储选中的颜色值
            skunums:[],
            selectedNums:undefined,
            sku_detail:'',
            selectedTab: ''
        }
    },
    activated () {
        this.getList();
        this.getskuList();
    },
    methods: {
        ...mapGetters(['nickid']),
        getListInit(){
            this.searchData.putaway = undefined
            this.searchData.status = undefined
            this.searchData.provider = ''
            this.searchData.orderno = ''
            this.searchData.phone = ''
            this.searchData.name = ''
            this.current = 1;
            this.selectedColor = undefined
            this.selectednums = undefined
            this.getList();
            this.getskuList();
        },
        handleColorChange() {
            this.updateSkuDetail();
        },
        handleNumsChange() {
            this.updateSkuDetail();
        },
        updateSkuDetail(){
            if (this.selectedColor && this.selectedNums) {
                this.sku_detail = `${this.selectedNums};${this.selectedColor}`;
            } else if (this.selectedColor) {
                this.sku_detail = this.selectedColor;
            } else if (this.selectedNums) {
                this.sku_detail = this.selectedNums;
            } else {
                this.sku_detail = '';  // 没有选中项时，清空 sku_detail
            }
        },
        getList() {
            let sta = ''
            let end = ''
            if(this.time.length>0){
              sta = new Date(this.timeTwo(Date.parse(this.time[0])/1000) + ' 00:00:00').getTime()
              end = new Date(this.timeTwo(Date.parse(this.time[1])/1000) + ' 23:59:59').getTime()
            }
            this.loading = true;
            let data = {
                page: this.current,
                num: this.pageSize,
                ...this.searchData,
                sta_time: sta,
                end_time: end,
                sku_detail:this.sku_detail
            }
            if(this.searchData.status == 'overdue'){
                data.overdue = this.searchData.status
                data.status = '';
            }
            if(this.searchData.status == 'defeat'){
                data.defeat = this.searchData.status
                data.status = '';
            }
            Order.OrderList(data).then(res => {
                this.data = res.result.map((value, key) => {
                    return { ...value, key }
                })
                this.loading = false
                this.total = parseInt(res.count)
            })
        },
        getskuList(){
            Order.skuList({}).then(res => {
                    console.log(res.result)
                    this.skucolor = [];
                    this.skunums = [];
                    res.result.forEach(item=>{
                        if(item.name == '颜色'){
                            this.skucolor=item.item
                        }
                        if(item.name == '内存'){
                            this.skunums=item.item
                        }
                    })
                })
        },
        GetPassword (uid,data) {
            // console.log(data)
            this.Password = true
            this.lentgoods = data.goods
            this.lentshop = data.shop
            this.statustwo = data.statustwo
        },
        changePagination (pagination) {
            this.current = pagination.current;
            this.pageSize = pagination.pageSize;
            // Object.keys(pagination).forEach(val => {
            //     this[val] = pagination[val]
            // })
            this.getList()
        },
        saveGudong (uid, methods, title, params = {}) {
            this.$confirm({
                title: `${title}`,
                content: `确定要${title}吗?`,
                centered: true,
                onOk: () => {
                    return new Promise((resolve, reject) => {
                        Member[methods]({ uid, ...params }).then(res => {
                            resolve()
                            this.getList()
                        }).catch(res => {
                            reject()
                        })
                    })
                }
            })
        },
        moneyConfirm (data) {
          console.log(this.time)
          return
            this.uid = data.userid
            this.isShowJf = true
        },
        //导出的方法
        exportExcel () {
            require.ensure([], () => {
                const { export_json_to_excel } = require('../../excel/Export2Excel')
                const tHeader = this.columns.map(v => v.title)
                const filterVal = this.columns.map(v => v.dataIndex)
                const list = JSON.parse(JSON.stringify(this.data)).map(v => {

                    return v
                })
                const data = this.formatJson(filterVal, list)
                export_json_to_excel(tHeader, data, '会员列表')
            })
        },

        formatJson (filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        }
    }
}
</script>

<style scoped lang="less">
.inputGroup {
    > div {
        margin-bottom: 20px;
    }
}

.radioTitle {
    display: block;
    font-size: 18px;
    padding: 20px 0px;
}

.radioStyle {
    display: block;
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
}
.juli {
    margin-bottom: 10px;
}
</style>
